'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sorry, please enter something valid';
  return function (value, values) {
    return value && /^[0-9a-zA-Z ,;.'()\-_&@\n\r]+$/.test(value) ? '' : (0, _getErrorMessage2.default)(errorMessage, {
      value: value,
      values: values
    });
  };
};